import { v1 as uuidv1 } from 'uuid';

function PricingTierTable(props){
        return ([
            <table className='table-2' key={uuidv1()}>
                <thead>
                    <tr>
                        <th>WEIGHT (G)</th>
                        <th>REC PER GRAM</th>
                        <th>REC TOTAL</th>
                        <th>MED PER GRAM</th>
                        <th>MED TOTAL</th>
                    </tr>
                </thead>

                <tbody>
                    {props.pricingDetails.map(tier => {
                        return(
                        <tr key={uuidv1()}>
                            <td>{tier.StartWeight}</td>
                            <td>{tier.Price}</td>
                            <td>{tier.StartWeight * tier.Price}</td>
                            <td>{tier.MedicalPrice}</td>
                            <td>{tier.StartWeight * tier.MedicalPrice}</td>
                        </tr>
                        );
                 })}
                 </tbody>

               
            </table>
        ]);
}

export default PricingTierTable;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/price-check/PricingTierTable.jsx